<template>
  <permission-guard situation="widget_management">
    <template>
      <router-link class="d-block mb-2" to="/admin/posts/widgets"
        >← ウィジェット一覧に戻る</router-link
      >
      <h2 class="headline mb-3">ウィジェット作成</h2>
      <widget-form :widget="widget" @update-widget="updateWidget" @save-widget="createWidget" />
    </template>
  </permission-guard>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import WidgetForm from './WidgetForm'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    PermissionGuard,
    WidgetForm
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'ウィジェット作成',
      widget: {
        name: null,
        content: null,
        device: null,
        page: null,
        morality: null,
        position: null,
        page_number: null,
        width: null,
        height: null,
        mapWidgetPosts: [],
        mapWidgetTags: []
      }
    }
  },
  methods: {
    createWidget () {
      const mapWidgetPostsAttributes = this.widget.mapWidgetPosts.map(
        (item) => {
          return {
            id: item.id,
            postId: item.post.id,
            _destroy: item.destroy
          }
        }
      )
      const widget = this.widget
      widget.mapWidgetPostsAttributes = mapWidgetPostsAttributes
      const mapWidgetTagsAttributes = this.widget.mapWidgetTags.map(
        (item) => {
          return {
            id: item.id,
            tagId: item.tag.id,
            _destroy: item.destroy
          }
        }
      )
      widget.mapWidgetTagsAttributes = mapWidgetTagsAttributes
      const query = { widget: this.widget }
      axios.post('/api/widgets', query).then(
        async () => {
          const payload = {
            status: 200,
            message: '新規ウィジェットを作成しました。'
          }
          await this.$store.dispatch(
            'SystemMessageStore/createMessage',
            payload
          )
          this.$router.push('/admin/posts/widgets')
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    updateWidget (widget) {
      this.widget = Object.assign({}, widget)
    }
  }
}
</script>
